export enum SubmissionDraftType {
    QuoteComparison = 'QuoteComparison',
}
